import React, { useState } from 'react'
import { durationValidation } from '../../Context/validation'
import { useFormik } from 'formik'
import { ToastContainer, toast } from 'react-toastify'
import Spinner from '../Spinner/spinner'
import { createDuration } from '../../Context/api'
import { statusCodes } from '../../Constants/generalConfig'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'

const AddDuration = () => {
    const [spinner, setSpinner] = useState(false)
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const navigate = useNavigate()
    const durations = [10, 15, 20, 30, 40, 45, 50, 60, 70, 80, 90, 100, 110, 120, 150, 180, 210, 240, 270, 300];
    const addDuration = useFormik({
        initialValues: {
            duration: ''
        },
        validationSchema: durationValidation,
        onSubmit: (values) => {
            const data = {
                duration: values.duration,
                userId: adminData?.userId,
            }
            setSpinner(true)
            axios.post(createDuration(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    toast.success(resp.data.message)
                    setSpinner(false)
                    setTimeout(() => {
                        navigate(-1)
                    }, 1000);


                }
                else {
                    setSpinner(false)
                    toast.error(resp.data.message)
                }
            })
        }
    })
    // console.log(addDuration.values, 'PPPP')
    return (
        <section>
            <ToastContainer />
            <div className="cus-padd cusheight">
                {spinner ? <Spinner /> : null}
                <header>
                    <h2 className='page-tittle'>
                        Add Duration
                    </h2>
                    <hr />
                </header>
                <form className="row g-3 mt-4" onSubmit={addDuration.handleSubmit}>
                    <div className="col-lg-6 mb-2">
                        <label className="form-label">Duration *</label>
                        <select className='form-select form-control' name="duration" value={addDuration.values.duration} onChange={addDuration.handleChange}>
                            <option hidden>Select duration(In minutes)</option>
                            {durations.map((duration) => (
                                <option key={duration} value={duration}>
                                    {duration} Minutes
                                </option>
                            ))}
                        </select>
                    </div>
                    {addDuration.touched.duration && addDuration.errors.duration ? (
                        <div style={{ color: "red", fontSize: "12px" }}>
                            {addDuration.errors.duration}
                        </div>
                    ) : null}
                    < div>
                        <button type="submit" className="btn btn-primary col-0">Submit</button>
                    </div>
                </form>
            </div>
        </section>
    )
}

export default AddDuration
